export const TEAM_HEADERS = ["Team name", "Team members", "Actions"];

export const TEAM_ACTIONS = Object.freeze({
    VIEW_TEAM: "VIEW_TEAM",
    DELETE_TEAM: "DELETE_TEAM",
});
